import React from 'react';
import styled from 'styled-components';
import { Card, Color, Icon as WebElementsIcon } from '@bb/elements-web';
import { camelCase, startCase } from 'lodash';
import { useSupraAccessDetailsPageContext } from '../SupraAccessDetailsPageContext';

const SupraAccessCard: React.FC = () => {
  const { subscription, planType, planCost, billingFrequency } =
    useSupraAccessDetailsPageContext();

  const keyTypeLabel = subscription?.type
    ? `${startCase(camelCase(subscription.type))} Key`
    : '';

  const title = keyTypeLabel
    ? `Supra Access - ${keyTypeLabel}`
    : 'Supra Access';

  return (
    <StyledCard
      title={
        <TitleRow>
          <IconBubble>
            <WebElementsIcon icon="keyOutlined" size={15} color="primary" />
          </IconBubble>
          <span>{title}</span>
        </TitleRow>
      }
      dataCy="supra-access-card"
    >
      <Label>Current Plan</Label>
      <Value>
        {planType === 'org' ? (
          'Managed by Organization'
        ) : (
          <>
            <PriceAmount>${planCost}</PriceAmount>
            {billingFrequency && (
              <PriceInterval> / {billingFrequency}</PriceInterval>
            )}
          </>
        )}
      </Value>
    </StyledCard>
  );
};

export default SupraAccessCard;

const StyledCard = styled(Card)`
  .ant-card-head-title {
    font-size: 20px;
    font-weight: 600;
    color: ${Color.PRIMARY_LIGHT_TEXT};
  }
  .ant-card-head {
    border-bottom: none;
    padding-bottom: 0;
    min-height: auto;
  }
  .ant-card-body {
    padding-top: 8px;
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconBubble = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${Color.BLUE_BG_SOFT};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Label = styled.div`
  font-size: 16px;
  color: ${Color.BODY_TEXT};
  margin-bottom: 4px;
`;

const Value = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 16px;
  color: ${Color.PRIMARY_LIGHT_TEXT};
`;

const PriceAmount = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${Color.PRIMARY_LIGHT_TEXT};
`;

const PriceInterval = styled.span`
  font-size: 16px;
  color: ${Color.PRIMARY_LIGHT_TEXT};
  margin-left: 4px;
`;
